<template>
  <view id="verifyStatus">
		<view class='a-s-main'>
		    <view v-if="searchdata.status=='1'">
		        <view class='a-s-item'>
		          <image src='../../static/image/verifying.png'></image>
		      </view>
		      <view class='f-color3 a-s-item'>正在认证中</view>
		      <view class='f-color3 a-s-item'>待匹配完成即可显示</view>
		    </view>
		    <view v-if="searchdata.status=='2'">
		        <view class='a-s-item'>
		          <image src='../../static/image/verifyed.png'></image>
		      </view>
		      <view class='f-color3 a-s-item'>认证成功</view>
		      <view class='f-color1 a-s-item a-s-verifyed color3' @click='seeresult' v-if="hasbtn">前去缴费</view>
		    </view>
		    <view v-if="searchdata.status=='3'">
		        <view class='a-s-item'>
		          <image src='../../static/image/fail.png'></image>
		      </view>
		      <view class='f-color3 a-s-item'>认证失败</view>
		      <view class='f-color3'>失败原因：{{searchdata.auditResult}}</view>
		      <view class='i-d-btn' @click='goadd'>
		        <view class=' color3'>重新认证</view>
		      </view>
		    </view>
		</view>
		<view class='a-s-m'>
		         <view @click="seeDetail">
		            <view class='f-color1'>查看详情</view>
		            <image src='../../static/image/arrowright.png'></image>
		        </view>
		        <view class="line"></view>
		         <view>
		            <view class='f-color1'>提交时间</view>
		            <view class='f-color3'>{{searchdata.gmtCreate}}</view>
		        </view>
		         <view v-if="searchdata.status!='1'">
		            <view class='f-color1'>完成时间</view>
		            <view class='f-color3'>{{searchdata.auditTime}}</view>
		        </view>
		</view>

	</view>

  
</template>
<script>
export default {
  name: "verifyStatus",
  data() {
   
    return {
                hasbtn:false,
				searchdata:{
					status:3,
					createTime:'202-20-120*'
				}
    }
  },
  	async created() {
			this.getRealNameRecord();
			
		},
		async onLoad(query){
			var that=this;
				switch(query && query.from) {
					case 'pay':
					that.hasbtn=true;
					break;
					default: // 正常流程
						that.hasbtn=false;
					break;
				}
		},
		methods: {
			goadd(){
				uni.navigateTo({
					url:'realNameAuthentication'
				})
			},
			seeresult(){
				uni.navigateTo({
					url: '/pages/platform/apply/pay?from=' + 'real'
				})
			},
			async getRealNameRecord () {
				let that=this;
				
				let res = await getRealNameRecord();
				if (res.success) {
					if(res.content){
					    this.searchdata=res.content}
				}
			},
			seeDetail(){
                
			},
		}
};
</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/components/user/verifyStatus.vue